import React, { useState } from 'react';

const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://labs.xmacna.ai/strategy-api'
  : '/api';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        const AUTH_KEY = 'strategy_auth_' + btoa('naocontapraninguem!');
        localStorage.setItem(AUTH_KEY, 'true');
        localStorage.setItem('xmacna_auth_token', data.token);
        if (data.refresh_token) {
          localStorage.setItem('xmacna_auth_refresh_token', data.refresh_token);
        }
        onLogin();
      } else {
        setError(data.message || 'Credenciais invalidas');
      }
    } catch (err) {
      setError('Erro ao conectar com o servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        <h1 style={styles.title}>
          <span style={styles.titleGradient}>XMACNA</span>
        </h1>
        <p style={styles.subtitle}>Strategy Dashboard</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="seu@email.com"
              disabled={loading}
              autoComplete="email"
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Senha</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="Digite sua senha"
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button
            type="submit"
            style={{
              ...styles.button,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>

          <p style={styles.hint}>Use seu email do Directus (os.xmacna.ai)</p>
        </form>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(to bottom, rgb(17, 24, 39), rgb(17, 24, 39))',
  },
  loginBox: {
    backgroundColor: '#1f2937',
    borderRadius: '12px',
    padding: '40px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
  },
  title: {
    margin: 0,
    textAlign: 'center' as const,
    marginBottom: '8px',
  },
  titleGradient: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
    background: 'linear-gradient(45deg, #3b82f6, #8b5cf6, #ec4899, #f43f5e)',
    backgroundSize: '300% 300%',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradientFlow 8s ease infinite',
  },
  subtitle: {
    color: '#9ca3af',
    textAlign: 'center' as const,
    marginBottom: '32px',
    fontSize: '1rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '20px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '8px',
  },
  label: {
    color: '#e5e7eb',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  input: {
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid #374151',
    backgroundColor: '#111827',
    color: '#e5e7eb',
    fontSize: '1rem',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  error: {
    color: '#f87171',
    fontSize: '0.875rem',
    margin: 0,
    textAlign: 'center' as const,
  },
  button: {
    padding: '14px',
    borderRadius: '8px',
    border: 'none',
    background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
    color: 'white',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
  },
  hint: {
    color: '#6b7280',
    fontSize: '0.75rem',
    textAlign: 'center' as const,
    margin: 0,
  },
};

export default Login;
